import { PrimaryRegularButton } from 'components/ReusableComponents/Button/RegularButtons'
import { TerciarySmallButton } from 'components/ReusableComponents/Button/SmallButtons'
import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import CustomHeader from 'components/ReusableComponents/HeaderTitles'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import Table from 'components/ReusableComponents/Table'
import moment from 'moment'
import { useEffect, useState } from 'react'
import restrictedDatesApi from 'services/api/restrictedtextingdate'
import canadianProvinces from 'static/addresses/canadianProvinces'
import usStates from 'static/addresses/usStates'

import styles from './RetrictedCallDates.module.scss'

const data = [
  {
    id: 7,
    date: '2022-01-01',
    name: 'All Saints Day',
    states: ['AK', 'AS'],
    provinces: [],
    isUSNational: false,
    isCanadaNational: false
  },
  {
    id: 2,
    date: '2022-01-17',
    name: 'Martin Luther King Jr. Day',
    states: ['LA', 'TX', 'FL', 'CA', 'NY'],
    provinces: ['National'],
    isUSNational: false,
    isCanadaNational: true
  },
  {
    id: 3,
    date: '2022-02-21',
    name: 'Presidents Day',
    states: ['LA'],
    provinces: ['ON'],
    isUSNational: false,
    isCanadaNational: false
  },
  {
    id: 4,
    date: '2022-05-30',
    name: 'Memorial Day',
    states: ['LA', 'TX', 'FL'],
    provinces: [],
    isUSNational: false,
    isCanadaNational: false
  },
  {
    id: 5,
    date: '2022-07-04',
    name: 'Independence Day',
    states: ['LA', 'TX', 'FL', 'National'],
    provinces: ['ON', 'QC', 'BC', 'AB'],
    isUSNational: true,
    isCanadaNational: false
  }
]

function getStatesText(event) {
  if (event.states.includes('National')) {
    return 'all US States'
  }

  if (event.states.length === 0) {
    return null
  }

  if (event.states.length === 1) {
    return usStates[event.states[0]]
  }

  return `${event.states.length} states`
}

const ProvinceHoverText = ({ event }) => {
  if (event.isCanadaNational) {
    return null
  }

  if (event.provinces.length < 2) {
    return null
  }

  return (
    <div className={styles.tooltip}>
      {event.provinces.map(province => canadianProvinces[province]).join(', ')}
    </div>
  )
}

const StateHoverText = ({ event }) => {
  if (event.isUSNational) {
    return null
  }

  if (event.states.length < 2) {
    return null
  }

  return (
    <div className={styles.tooltip}>
      {event.states.map(state => usStates[state]).join(', ')}
    </div>
  )
}

function getProvincesText(event) {
  if (event.provinces.includes('National')) {
    return 'all Canadian Provinces'
  }

  if (event.provinces.length === 0) {
    return null
  }

  if (event.provinces.length === 1) {
    return canadianProvinces[event.provinces[0]]
  }

  return `${event.provinces.length} provinces`
}

const AddEditDialog = props => {
  const { onClose, onReset, id } = props

  const [selectedStates, setSelectedStates] = useState(props.states || [])
  const [selectedProvinces, setSelectedProvinces] = useState(props.provinces || [])
  const [stateFilterValue, setStateFilterValue] = useState('')
  const [provinceFilterValue, setProvinceFilterValue] = useState('')

  const [name, setName] = useState(props.name || '')
  const [date, setDate] = useState(moment(props.date).format('YYYY-MM-DD') || '')

  function handleSave() {
    if (id) {
      restrictedDatesApi
        .update({
          id,
          name,
          date,
          states: selectedStates,
          provinces: selectedProvinces
        })
        .then(() => {
          onClose()
        })
    } else {
      restrictedDatesApi
        .add({
          name,
          date,
          states: selectedStates,
          provinces: selectedProvinces
        })
        .then(() => {
          onClose()
        })
    }
  }

  function handleSaveAndAnother() {
    if (id) {
      restrictedDatesApi.update({
        id,
        name,
        date,
        states: selectedStates,
        provinces: selectedProvinces
      })
      onReset()
    } else {
      restrictedDatesApi.add({
        name,
        date,
        states: selectedStates,
        provinces: selectedProvinces
      })
      onReset()
    }
  }

  return (
    <ConfirmationDialog
      title={'Add New Restricted Call Date'}
      onClose={onClose}
      theme="blacklist"
      maxWidth={600}
      onConfirm={handleSave}
      isRejectButtonDisabled={
        name === '' ||
        date === '' ||
        (selectedStates.length === 0 && selectedProvinces.length === 0)
      }
      isButtonDisabled={
        name === '' ||
        date === '' ||
        (selectedStates.length === 0 && selectedProvinces.length === 0)
      }
      onReject={handleSaveAndAnother}
      positiveMessage="Save and close"
      negativeMessage="Save and add another"
    >
      <div className={styles.dialogWrapper}>
        <div>
          <TextInput
            label="Name"
            className={styles.dialogNameInput}
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </div>
        <div>
          <TextInput
            label="Date"
            type="date"
            className={styles.dialogDateInput}
            value={date}
            onChange={e => setDate(e.target.value)}
          />
        </div>
        <div className={styles.stateProvinceWrapper}>
          <div className={styles.stateProvinceContainer}>
            <p className={styles.label}>
              US states (
              {selectedStates.includes('National') ? 'all' : selectedStates.length}{' '}
              selected)
            </p>
            <div className={styles.stateProvinceBox}>
              <input
                type="search"
                value={stateFilterValue}
                onChange={e => setStateFilterValue(e.target.value)}
                placeholder="Filter states"
                className={styles.stateProvinceFilter}
              />
              <label className={styles.dialogCheckbox}>
                <input
                  type="checkbox"
                  id="usNational"
                  checked={selectedStates.includes('National')}
                  onChange={e =>
                    e.target.checked
                      ? setSelectedStates(['National'])
                      : setSelectedStates([])
                  }
                />
                <label htmlFor="usNational">National (all states)</label>
              </label>
              {Object.keys(usStates)
                .filter(
                  state =>
                    stateFilterValue === '' ||
                    usStates[state].toUpperCase().includes(stateFilterValue.toUpperCase())
                )
                // .slice(0, 5)
                .map(stateCode => (
                  <label key={stateCode} className={styles.dialogCheckbox}>
                    <input
                      type="checkbox"
                      id={stateCode}
                      checked={selectedStates.includes(stateCode)}
                      disabled={selectedStates.includes('National')}
                      onChange={() => {
                        if (selectedStates.includes(stateCode)) {
                          setSelectedStates(selectedStates.filter(s => s !== stateCode))
                        } else {
                          setSelectedStates([...selectedStates, stateCode])
                        }
                      }}
                    />
                    <label htmlFor={stateCode}>{usStates[stateCode]}</label>
                  </label>
                ))}
            </div>
          </div>
          <div className={styles.stateProvinceContainer}>
            <p className={styles.label}>
              Canadian provinces (
              {selectedProvinces.includes('National') ? 'all' : selectedProvinces.length}{' '}
              selected)
            </p>
            <div className={styles.stateProvinceBox}>
              <input
                type="search"
                value={provinceFilterValue}
                onChange={e => setProvinceFilterValue(e.target.value)}
                placeholder="Filter provinces"
                className={styles.stateProvinceFilter}
              />
              <label className={styles.dialogCheckbox}>
                <input
                  type="checkbox"
                  id="canadaNational"
                  checked={selectedProvinces.includes('National')}
                  onChange={e =>
                    e.target.checked
                      ? setSelectedProvinces(['National'])
                      : setSelectedProvinces([])
                  }
                />
                <label htmlFor="canadaNational">National (all provinces)</label>
              </label>
              {Object.keys(canadianProvinces)
                .filter(
                  province =>
                    provinceFilterValue === '' ||
                    canadianProvinces[province]
                      .toUpperCase()
                      .includes(provinceFilterValue.toUpperCase())
                )
                // .slice(0, 5)
                .map(provinceCode => (
                  <label key={provinceCode} className={styles.dialogCheckbox}>
                    <input
                      type="checkbox"
                      id={provinceCode}
                      checked={selectedProvinces.includes(provinceCode)}
                      disabled={selectedProvinces.includes('National')}
                      onChange={() => {
                        if (selectedProvinces.includes(provinceCode)) {
                          setSelectedProvinces(
                            selectedProvinces.filter(s => s !== provinceCode)
                          )
                        } else {
                          setSelectedProvinces([...selectedProvinces, provinceCode])
                        }
                      }}
                    />
                    <label htmlFor={provinceCode}>
                      {canadianProvinces[provinceCode]}
                    </label>
                  </label>
                ))}
            </div>
          </div>
        </div>
      </div>
    </ConfirmationDialog>
  )
}

const RestrictedCallDates = () => {
  const [showAddDialog, setShowAddDialog] = useState(false)

  const [activeEventToEdit, setActiveEventToEdit] = useState(null)

  const [isLoading, setIsLoading] = useState(true)

  const [selectedCountry, setselectedCountry] = useState()

  const [selectedYear, setselectedYear] = useState(moment().format('YYYY'))

  const [searchQuery, setSearchQuery] = useState('')

  const [data, setData] = useState([])

  useEffect(() => {
    restrictedDatesApi
      .list({
        countryFilterKind: selectedCountry,
        year: selectedYear
      })
      .then(res => {
        setData(res)
        setIsLoading(false)
      })
  }, [selectedCountry, selectedYear])

  function handleCloseDialog() {
    setIsLoading(true)
    setShowAddDialog(false)
    setActiveEventToEdit(null)
    restrictedDatesApi
      .list({
        countryFilterKind: selectedCountry,
        year: selectedYear
      })
      .then(res => {
        setData(res)
        setIsLoading(false)
      })
  }

  if (isLoading) {
    return <LoadingIndicator />
  }

  return (
    <div className={styles.wrapper}>
      {showAddDialog && (
        <AddEditDialog
          onClose={handleCloseDialog}
          onReset={() => {
            setShowAddDialog(false)
            setActiveEventToEdit({})
          }}
        />
      )}
      {activeEventToEdit && (
        <AddEditDialog
          onClose={handleCloseDialog}
          onReset={() => {
            setActiveEventToEdit(null)
            setShowAddDialog(true)
          }}
          {...activeEventToEdit}
        />
      )}
      <CustomHeader title="Restricted Call Dates" width={900} />
      <div className={styles.filterBar}>
        <div className={styles.filterBarLeft}>
          <PrimaryRegularButton
            className={styles.addButton}
            onClick={() => setShowAddDialog(true)}
          >
            Add a new date
          </PrimaryRegularButton>
        </div>
        <div className={styles.filterBarRight}>
          <TextInput
            className={styles.searchInput}
            type="search"
            placeholder="Search with name"
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
          />
          <Dropdown
            className={styles.stateDropdown}
            value={selectedCountry}
            onChange={e => setselectedCountry(e.target.value)}
            options={{
              All: ' All States and Provinces',
              US: 'All US States',
              CA: 'All Canadian Provinces'
            }}
          />
          <Dropdown
            className={styles.yearDropdown}
            value={selectedYear}
            onChange={e => setselectedYear(e.target.value)}
            options={{
              ...Array.from({ length: 5 }, (v, k) => k).reduce(
                (acc, val) => ({
                  ...acc,
                  [moment().subtract(val, 'years').format('YYYY')]: moment()
                    .subtract(val, 'years')
                    .format('YYYY')
                }),
                {}
              )
            }}
          />
        </div>
      </div>
      <div className={styles.tableHolder}>
        <Table widths={[120, 400, 300, 200]} className={styles.table}>
          <Table.TitleRow>
            <Table.TitleCell>Date</Table.TitleCell>
            <Table.TitleCell>Name</Table.TitleCell>
            <Table.TitleCell>State/Province</Table.TitleCell>
            <Table.TitleCell></Table.TitleCell>
          </Table.TitleRow>
          {data
            .filter(item => item.name.toLowerCase().includes(searchQuery.toLowerCase()))
            .map(item => (
              <Table.Row className={styles.row} key={item.id}>
                <Table.Cell className={styles.cell}>
                  <span className={styles.date}>{moment(item.date).format('MMM D')}</span>
                </Table.Cell>
                <Table.Cell className={styles.cell}>{item.name}</Table.Cell>
                <Table.Cell className={styles.cell}>
                  <span className={styles.stateProvince}>
                    {getStatesText(item)}
                    <StateHoverText event={item} />
                  </span>
                  <span>{getStatesText(item) && getProvincesText(item) && ', '}</span>
                  <span className={styles.stateProvince}>
                    {getProvincesText(item)}
                    <ProvinceHoverText event={item} />
                  </span>
                </Table.Cell>
                <Table.Cell className={styles.ctaCell}>
                  <TerciarySmallButton
                    className={styles.editButton}
                    onClick={() => setActiveEventToEdit(item)}
                  >
                    Edit
                  </TerciarySmallButton>
                </Table.Cell>
              </Table.Row>
            ))}
        </Table>
      </div>
    </div>
  )
}

export default RestrictedCallDates
